import { ActivityIndicator, View } from 'react-native';

import { WebDiv } from 'components/WebDiv';

const PlayerLoading = () => {
  return (
    <WebDiv
      className="navigation-container navigation-priority"
      style={{ position: 'absolute', width: '100%', height: '100%' }}>
      <View
        style={{
          position: 'absolute',
          backgroundColor: '#000',
          width: '100%',
          height: '100%',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        <ActivityIndicator size="large" color="#fff" />
      </View>
    </WebDiv>
  );
};

export default PlayerLoading;
